import script from "./SoffitFascia05Wraps.vue?vue&type=script&setup=true&lang=js"
export * from "./SoffitFascia05Wraps.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__